import { OpenPositionType } from "@/api-schema-enums";
import { BaseFilterProps, Filter, FilterData } from "@/components/filter/_types";
import { FilterComponent } from "@/components/filter/base-filter";
import { JSX } from "react";

export class OpenPositionTypeFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id = "type";
  readonly labelSingular = "fia:FilterType";
  readonly labelPlural = "fia:FilterType";
  readonly placeholder = "fia:FilterType";
  readonly searchPlaceholder = "common:Search";
  readonly emptyText = "fia:NoOptionFound";
  body = {};
  parameters = {};

  getData(): FilterData {
    return {
      options: [
        { id: OpenPositionType.Invoice, name: "fia:Receivable" },
        { id: OpenPositionType.Payment, name: "fia:Payment" },
      ],
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps): JSX.Element {
    return <FilterComponent filter={this} {...props} />;
  }
}
